import type { IStudio } from '../../../screens/Dashboard/SubComponents/Studio/interfaces/Studio.interface';
import { TemplateType } from '../../../screens/Dashboard/SubComponents/Studio/interfaces/sub-interfaces/Template.interface';

const SixTemplate: IStudio = {
  id: '0',
  version: '0.1.0',
  type: TemplateType.Six,
  output: {
    quality: {
      audio: 1,
      video: 1,
    },
    sizes: {
      height: 1080,
      width: 1920,
    },
  },
  areas: [
    {
      id: 'area-1',
      label: 'area 1',
      bounds: {
        width: 33,
        height: 49.5,
        top: 0,
        left: 0,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
    {
      id: 'area-2',
      label: 'area 2',
      bounds: {
        width: 33,
        height: 49.5,
        top: 0,
        left: 33.5,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
    {
      id: 'area-3',
      label: 'area 3',
      bounds: {
        width: 33,
        height: 49.5,
        top: 0,
        left: 67,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },

    {
      id: 'area-4',
      label: 'area 4',
      bounds: {
        width: 33,
        height: 49.5,
        top: 50.5,
        left: 0,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
    {
      id: 'area-5',
      label: 'area 5',
      bounds: {
        width: 33,
        height: 49.5,
        top: 50.5,
        left: 33.5,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
    {
      id: 'area-6',
      label: 'area 6',
      bounds: {
        width: 33,
        height: 49.5,
        top: 50.5,
        left: 67,
        zIndex: 1,
      },
      media: {
        bounds: {
          width: 100,
          height: 100,
          top: 0,
          left: 0,
        },
        resource: null,
      },
    },
  ],
};

export default SixTemplate;
